import { memoSanitize } from '@axa-asia/emma-safely-set-inner-html';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { goToView } from '../../../../actions/historyActions';
import { t } from '../../../../locales';
import { resolveLocalizedText, isApp } from '../../../../utils';
import './styles.scss';
import { goto, hideBackButton } from '../../../../actions/historyActions';
import {
  getOffersFormConfig,
  getOffersFormData,
} from '../../selectors/offersSelector';
import BackNavButton from '../../components/BackNavButton';
import browserHistory from '../../../../stores/browserHistory';

export interface OffersFormSuccessContainerProps {
  offersFormConfig: any;
  offersSubmitResponse: any;
  onHideBackButton: () => void;
}

export interface OffersFormSuccessContainerState {}

export class OffersFormSuccessContainer extends Component<
  OffersFormSuccessContainerProps,
  OffersFormSuccessContainerState
> {
  constructor(props: any) {
    super(props);

    this.onClickOk = this.onClickOk.bind(this);
  }

  componentDidMount() {
    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          action: '@CUST/HIDE_BACK_BUTTON',
        }),
      );
    }
  }

  onClickOk() {
    goToView('emma-my-privileges/direct');
    // browserHistory.push('/marketplace/myprivileges');
  }

  render() {
    const { offersFormConfig, offersSubmitResponse } = this.props;
    const checkIsApp = isApp();

    // {!checkIsApp && <BackNavButton backPath="emma-my-privileges-show-me" />}
    return (
      <div className="emma-stylesheet-grid-system offers-form-success-container">
        {offersFormConfig.title !== '' && (
          <div className="offers-form-success__title">
            {offersSubmitResponse.msg === 'OFFERS_COMFIRM_SUCCESS_MSG' ||
            offersSubmitResponse.msg === 'OFFERS_COMFIRM_UNSUCCESS_MSG'
              ? offersFormConfig.title
              : offersSubmitResponse.productName}
          </div>
        )}
        <div className="offers-form-success__sub-title">
          {t(offersSubmitResponse.title)}
        </div>
        <div
          className="offers-form-success__msg"
          dangerouslySetInnerHTML={{
            __html: memoSanitize(
              offersSubmitResponse.msg === 'OFFERS_COMFIRM_SUCCESS_MSG' ||
                offersSubmitResponse.msg === 'OFFERS_COMFIRM_UNSUCCESS_MSG'
                ? t(offersSubmitResponse.msg).replace(
                    '${tel}',
                    '<a href="tel:85230705016">(852) 3070 5016</a>',
                  )
                : offersSubmitResponse.msg,
            ),
          }}
        ></div>
        <div className="offers-form-success__btn">
          <button
            className="emma-stylesheet-primary-default-button"
            onClick={this.onClickOk}
            data-enable-ga
            data-ga-type="button"
          >
            {t(offersSubmitResponse.buttonText)}
          </button>
        </div>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const offersFormConfig = getOffersFormConfig(state);
    const { offersSubmitResponse } = getOffersFormData(state);

    return {
      offersFormConfig: {
        title:
          offersFormConfig && offersFormConfig.title
            ? resolveLocalizedText(offersFormConfig.title)
            : '',
      },
      offersSubmitResponse: {
        title:
          offersSubmitResponse && offersSubmitResponse.title
            ? offersSubmitResponse.title
            : '',
        msg:
          offersSubmitResponse && offersSubmitResponse.msg
            ? offersSubmitResponse.msg
            : '',
        buttonText:
          offersSubmitResponse && offersSubmitResponse.buttonText
            ? offersSubmitResponse.buttonText
            : 'DENSELY_BUTTON_OK',
      },
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      onHideBackButton: () => dispatch(hideBackButton()),
    };
  }
}

export default connect(
  OffersFormSuccessContainer.mapStateToProps,
  OffersFormSuccessContainer.mapDispatchToProps,
)(OffersFormSuccessContainer);
